import React, { useEffect } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { BackButton, Drawer } from '../../components';
import useMaterialDetails from './hooks';

/**
 * Components
 */
import {
  Head, Image, Description, Title, Loading
} from './components';
import EventTracker from '../../helpers';


const Container = styled.div`
  max-height: auto;
  overflow: auto;
  margin-bottom: 20px;
`;

const Drawers = styled.div`
  margin: 30px 0;
`;


const MaterialDetails = ({ districtId, localityId, location }) => {
  /**
   * Get material id from router
   */
  const materialId = location.state.id;
  const { details, error, loading } = useMaterialDetails(localityId, materialId);

  useEffect(() => {
    const value = materialId;
    EventTracker('CMS - Material Page', value);
  }, [materialId, districtId, localityId]);

  return (
    <Container>
      {
        loading && <Loading />
      }
      {
        !error && Object.keys(details).length
          ? (
            <div>
              <BackButton>{details.name}</BackButton>
              <Image images={details.images} alt={details.name} />
              <Head>{details.disposal_header}</Head>
              <Title>{details.name}</Title>
              <Description>
                {details.disposal_body}
              </Description>
              {
                details.links.length
                  ? (
                    <Drawers>
                      {
                        details.links.map((link) => (
                          <Drawer
                            key={link.drawer_title}
                            link={link}
                          />
                        ))
                      }
                    </Drawers>
                  ) : null
              }
            </div>
          ) : null
      }
    </Container>
  );
};

const mapStateToProps = (state) => ({
  localityId: state.app.localityId,
  districtId: state.app.districtId
});

export default withRouter(connect(mapStateToProps)(MaterialDetails));
